import React  from 'react';
import { Dialog, DialogActions,  DialogTitle, Button, Typography, Box } from '@mui/material';
import logoutImage from './../../assets/images/logout.png'
import {  useNavigate } from 'react-router-dom';
import {logout} from "store/slices/userLoginAction"
import { connect } from "react-redux";

const LogoutConfirmationPopup = ({ open, onClose ,logout}) => {
    const navigate = useNavigate()
  const handleConfirmDelete = () => {
    logout()
    navigate('/')
    onClose();
  };

  const handleCancel = () => {
    onClose(); 
  };

  return (
    <Dialog open={open} onClose={onClose} >
      <DialogTitle sx={{ textAlign: 'center' }}>
        <img
          src={logoutImage} 
          alt="Delete Icon"
          style={{ width: '60px', height: '60px', marginBottom:'4px' }}
        />
         <Typography
          variant="h6"
          sx={{
            color: '#D52F44',
            textAlign: 'center',
            marginBottom: '10px',
            fontWeight: 'bold',
            fontSize:'14px'
          }}
        >
          Are You Sure?
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#8F9BA5',
            textAlign: 'center',
            fontSize:'14px'
          }}
        >
          You want to Logout
        </Typography>
      </DialogTitle>
      
      <DialogActions sx={{ justifyContent: 'space-evenly' }}>
        <Button
          onClick={handleConfirmDelete}
          type="submit"
          variant="outlined"
          sx={{
            height: '50px',
            width: '131px',
            borderRadius: '10px',
            borderColor: '#D52F44',
            color: 'white',
            backgroundColor: '#D52F44',
            fontSize: '14px',
            '&:hover': {
              borderColor: '#D52F44',
              backgroundColor: '#D52F44',
              color: 'white',
            },
            textTransform: 'none',
            marginLeft:'20px'
          }}
        >
          Logout
        </Button>
        <Button
          onClick={handleCancel}
          variant="outlined"
          sx={{
            fontSize: '14px',
            textTransform: 'none',
            marginRight: 2,
            height: '50px',
            width: '131px',
            borderRadius: '10px',
            marginLeft: 3,
            borderColor: 'gray',
            color: 'gray',
            '&:hover': {
              borderColor: 'darkgray',
            },
            marginRight:'20px'
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(null,{logout})(LogoutConfirmationPopup)
